/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'arrow-circle-left': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M23.937 11.75c-6.73 0-12.187 5.456-12.187 12.188s5.457 12.188 12.187 12.188c6.731 0 12.188-5.456 12.188-12.188S30.668 11.75 23.937 11.75zM30 25.5c0 .275-.225.5-.5.5H24v3.407c0 .275-.173.357-.384.18l-6.398-5.329a.403.403 0 0 1 0-.641l6.398-5.329c.211-.177.384-.096.384.18V22h5.5c.275 0 .5.225.5.5v3z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/arrow-circle-left.js